"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _Tooltip = _interopRequireDefault(require("../../../../components/Tooltip"));
var _theme = require("../../../../theme");
var _system = require("@mui/system");
/**
 * @param data
 * @param selected
 * @param onSelect
 * @param classes
 * @param id
 * @returns {*}
 * @constructor
 */
var DivisionListItem = function DivisionListItem(_ref) {
  var data = _ref.data,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    id = _ref.id,
    testid = _ref.testid;
  var DivisionCard = (0, _system.styled)("div")(function (_ref2) {
    var theme = _ref2.theme;
    return {
      '&:hover': {
        borderLeft: "".concat(theme.palette.primary.main, " solid 5px")
      },
      backgroundColor: selected ? theme.palette.primary.light : _theme.colors.surface,
      borderLeft: selected ? "".concat(theme.palette.primary.main, " solid 5px") : "".concat(_theme.colors.surface, " solid 5px"),
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      cursor: 'pointer',
      marginBottom: '0',
      padding: '10px 10px 7px 8px',
      position: 'relative',
      width: '100%',
      overflow: 'hidden'
    };
  });
  return /*#__PURE__*/_react["default"].createElement(DivisionCard, {
    id: id || testid,
    onClick: onSelect
  }, data.description ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    tip: data.description,
    placement: "top-start"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    color: "inherit",
    medium: true,
    display: "inline"
  }, data.title)) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    color: "inherit",
    medium: true,
    display: "inline"
  }, data.title));
};
var _default = exports["default"] = DivisionListItem;